import React from 'react';
import './Checkbox.scss';

export default function Checkbox({
  checked,
  onClick,
  value,
  label,
  className,
}: {
  value?: string;
  onClick?: (value: string) => void;
  className?: string;
  checked: boolean;
  label?: string;
}): JSX.Element {
  const onClickSpan = (event: React.SyntheticEvent<HTMLSpanElement>) =>
    onClick(event.currentTarget.dataset.value);
  const onClickInput = (event: React.SyntheticEvent<HTMLInputElement>) =>
    onClick(event.currentTarget.value);
  return (
    <div className={`checkbox-container ${className}`}>
      <label htmlFor={value}>{label}</label>
      <input
        onChange={() => {}}
        type="checkbox"
        checked={checked}
        onClick={onClickInput}
        id={value}
        value={value}
      />
      <span
        onClick={onClickSpan}
        id={value}
        data-value={value}
        className={label ? 'check-mark-with-label' : 'check-mark-without-label'}
      />
    </div>
  );
}
